import loader from './loader';
const imagesHtml = {
    loader
}
export default imagesHtml;